<template>
    <div id="csContainer">
        <div class="fogdiv">
            <el-checkbox class="shadow" size="small " v-model="checked" label="剖切" border></el-checkbox>
        </div>

    </div>
</template>
<script>
import util from '../../components/util'
import { constants } from 'crypto';
export default {
    data () {
        return {
          entity:  null,
          checked: true,
        }
    },
    mounted(){
        this.init()
    },
    watch:{
        checked:function (val) {
            if(this.entity !== null){
                if(val){
                    this.entity.box.material = Cesium.Color.WHITE.withAlpha(0.3);
                    this.entity.box.outline = true;
                    this.entity.box.outlineColor = Cesium.Color.WHITE;
                }else{
                    this.entity.box.material = Cesium.Color.WHITE.withAlpha(0);
                    this.entity.box.outline = false;
                }
            }

        }
    },
    methods:{
        init(){
            let viewer=util.getViewer('csContainer',{
                // imageryProvider: new Cesium.UrlTemplateImageryProvider({
                //     url: 'http://www.google.cn/maps/vt?lyrs=s@716&x={x}&y={y}&z={z}'
                // }),
                shouldAnimate : true,
                terrainProvider: Cesium.createWorldTerrain({
                    requestVertexNormals: true,
                    requestWaterMask: true
                })
            });
            var clippingPlanesEnabled = true;
            var edgeStylingEnabled = true;

            var tileset;
            viewer.scene.globe.depthTestAgainstTerrain = true;
            var globe = viewer.scene.globe;
            var position = Cesium.Cartesian3.fromRadians(
                -2.0862979473351286,
                0.6586620013036164,
                1400.0
            );

             this.entity = viewer.entities.add({
                position: position,
                box: {
                    dimensions: new Cesium.Cartesian3(1400.0, 1400.0, 2800.0),
                    material: Cesium.Color.WHITE.withAlpha(0.3),
                    outline: true,
                    outlineColor: Cesium.Color.WHITE,
                },
            });

            // viewer.entities.add({
            //     position: position,
            //     model: {
            //         uri: "/demo/static/data/models/Cesium_Man.glb",
            //         minimumPixelSize: 128,
            //         maximumScale: 800
            //     },
            // });

            globe.depthTestAgainstTerrain = true;
            globe.clippingPlanes = new Cesium.ClippingPlaneCollection({
                modelMatrix: this.entity.computeModelMatrix(Cesium.JulianDate.now()),
                planes: [
                    new Cesium.ClippingPlane(
                        new Cesium.Cartesian3(1.0, 0.0, 0.0),
                        -700.0
                    ),
                    new Cesium.ClippingPlane(
                        new Cesium.Cartesian3(-1.0, 0.0, 0.0),
                        -700.0
                    ),
                    new Cesium.ClippingPlane(
                        new Cesium.Cartesian3(0.0, 1.0, 0.0),
                        -700.0
                    ),
                    new Cesium.ClippingPlane(
                        new Cesium.Cartesian3(0.0, -1.0, 0.0),
                        -700.0
                    ),
                ],
                edgeWidth: 0.0,
                edgeColor: Cesium.Color.WHITE,
                enabled: clippingPlanesEnabled,
                // unionClippingRegions: true
            });
            globe.backFaceCulling = true;
            globe.showSkirts = true;

            viewer.trackedEntity = this.entity;
        },




    }
}
</script>
<style scoped>
    .fogdiv {
        position: absolute;
        margin-left: 25px;
        margin-top: 7px;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .shadow{
        color:white !important;
    }
    #csContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
